"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertISO8601ToMMSS = exports.convertISO8601ToSS = exports.convertMMSSToSS = exports.convertSSToMMSS = exports.convertMSToMMSS = exports.toTwoDigitsNumber = void 0;
var tslib_1 = require("tslib");
function toTwoDigitsNumber(number) {
    return number <= 9 ? "0".concat(number) : String(number);
}
exports.toTwoDigitsNumber = toTwoDigitsNumber;
function convertMSToMMSS(durationMilliseconds) {
    return convertSSToMMSS(durationMilliseconds / 1000);
}
exports.convertMSToMMSS = convertMSToMMSS;
function convertSSToMMSS(durationSec) {
    durationSec = Math.floor(durationSec || 0);
    var chunks = [];
    do {
        chunks.unshift(toTwoDigitsNumber(durationSec % 60));
        durationSec = Math.floor(durationSec / 60);
    } while (durationSec > 0);
    if (chunks.length < 2) {
        chunks.unshift('00');
    }
    return chunks.join(':');
}
exports.convertSSToMMSS = convertSSToMMSS;
function convertMMSSToSS(duration) {
    if (!duration) {
        return 0;
    }
    return duration
        .split(':')
        .reverse()
        .reduce(function (acc, chunk, i) {
        return acc + Number(chunk) * Math.pow(60, i);
    }, 0);
}
exports.convertMMSSToSS = convertMMSSToSS;
function convertISO8601ToSS(durationStr) {
    return durationStr ? convertMMSSToSS(convertISO8601ToMMSS(durationStr)) : 0;
}
exports.convertISO8601ToSS = convertISO8601ToSS;
function convertISO8601ToMMSS(durationStr) {
    if (!durationStr) {
        return '00:00';
    }
    var _a = tslib_1.__read(durationStr.match(/^P(?:(\d+)D)?T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/) || []), parts = _a.slice(1);
    var numParts = parts.map(function (part) { return Number(part) || 0; });
    var _b = tslib_1.__read(numParts, 4), numDays = _b[0], numHours = _b[1], numMinutes = _b[2], numSeconds = _b[3];
    var _c = tslib_1.__read([
        numDays * 24 + numHours,
        numMinutes,
        numSeconds,
    ].map(toTwoDigitsNumber), 3), hours = _c[0], minutes = _c[1], seconds = _c[2];
    if (hours === '00') {
        return "".concat(minutes, ":").concat(seconds);
    }
    return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
}
exports.convertISO8601ToMMSS = convertISO8601ToMMSS;
//# sourceMappingURL=time.js.map